export default __webpack_public_path__ + "static/media/Arrow.f0185a5c.svg";